<div
  class="overflow-y-auto"
  style="background-color: #f2f2f2"
>
  <div class="header1 d-flex align-items-center px-4">
    <h1
      class="m-0"
      style="font-weight: 300; color: green; font-size: xx-large"
    >
      <span style="font-weight: 600">
        <strong><i>Fidelity</i></strong>
      </span>
      &nbsp;PrimePortal
    </h1>
  </div>
  <div style="margin: 15vh auto">
    <router-outlet />
  </div>
  <div
    class="disclosure"
    style="text-align: left; margin: 40px; max-width: 1000px"
  >
    <p>
      By using or logging into this website, you consent to the use of cookies as described in our
      <a
        href="https://prime.fidelity.com/app/item/RD_13569_19515.html?pos=F"
        target="_blank"
      >
        Privacy Policy.
      </a>
      For Login support, please email
      <a href="mailto:Fidelityloginsupport@fmr.com">Fidelityloginsupport&#64;fmr.com</a>
      . For your protection, inactive sessions in secured areas are timed out after four
      hours.Fidelity Prime Services is a part of Fidelity Capital Markets, a division of National
      Financial Services LLC, Member NYSE, SIPC
    </p>
  </div>

  <footer class="px-4">
    <div class="flex-container general-text">
      <div style="width: 40%">
        <div>© 2005 - {{ currentYear() }} FMR LLC. All Rights Reserved.</div>
        <div>773609.3.0</div>
      </div>
      <div style="width: 60%; text-align: right">
        <a
          href="https://prime.fidelity.com/app/popup/item/RD_13569_19469.html"
          target="_blank"
        >
          Browser Requirements
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;

        <a
          href="https://prime.fidelity.com/app/popup/item/RD_13569_19466.html"
          target="_blank"
        >
          User Agreement
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;

        <a
          href="https://prime.fidelity.com/app/item/RD_13569_19515.html?pos=F"
          target="_blank"
        >
          Privacy
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;

        <a
          href="https://prime.fidelity.com/app/item/RD_13569_44840.html?pos=F"
          target="_blank"
        >
          Security
        </a>
      </div>
    </div>
  </footer>
</div>
